const name = 'products';

export const GET_PRODUCTS_LIST_REQUEST = `${name}/GET_PRODUCTS_LIST_REQUEST`;
export const GET_PRODUCTS_LIST_SUCCESS = `${name}/GET_PRODUCTS_LIST_SUCCESS`;
export const GET_PRODUCTS_LIST_FAILURE = `${name}/GET_PRODUCTS_LIST_FAILURE`;

export const GET_PRODUCTS_DETAILS_REQUEST = `${name}/GET_PRODUCTS_DETAILS_REQUEST`;
export const GET_PRODUCTS_DETAILS_SUCCESS = `${name}/GET_PRODUCTS_DETAILS_SUCCESS`;
export const GET_PRODUCTS_DETAILS_FAILURE = `${name}/GET_PRODUCTS_DETAILS_FAILURE`;

export const UPDATE_PRODUCTS_DETAILS_REQUEST = `${name}/UPDATE_PRODUCTS_DETAILS_REQUEST`;
export const UPDATE_PRODUCTS_DETAILS_SUCCESS = `${name}/UPDATE_PRODUCTS_DETAILS_SUCCESS`;
export const UPDATE_PRODUCTS_DETAILS_FAILURE = `${name}/UPDATE_PRODUCTS_DETAILS_FAILURE`;

export const GET_PRODUCT_VARIATIONS_DETAILS_REQUEST = `${name}/GET_PRODUCT_VARIATIONS_DETAILS_REQUEST`;
export const GET_PRODUCT_VARIATIONS_DETAILS_SUCCESS = `${name}/GET_PRODUCT_VARIATIONS_DETAILS_SUCCESS`;
export const GET_PRODUCT_VARIATIONS_DETAILS_FAILURE = `${name}/GET_PRODUCT_VARIATIONS_DETAILS_FAILURE`;

export const GET_PRODUCT_BY_BARCODE_REQUEST = `${name}/GET_PRODUCT_BY_BARCODE_REQUEST`;
export const GET_PRODUCT_BY_BARCODE_SUCCESS = `${name}/GET_PRODUCT_BY_BARCODE_SUCCESS`;
export const GET_PRODUCT_BY_BARCODE_FAILURE = `${name}/GET_PRODUCT_BY_BARCODE_FAILURE`;

export const MASS_EDIT_CHANGE_STATUS_REQUEST = `${name}/MASS_EDIT_CHANGE_STATUS_REQUEST`;
export const MASS_EDIT_CHANGE_STATUS_SUCCESS = `${name}/MASS_EDIT_CHANGE_STATUS_SUCCESS`;
export const MASS_EDIT_CHANGE_STATUS_FAILURE = `${name}/MASS_EDIT_CHANGE_STATUS_FAILURE`;

export const MASS_EDIT_SET_SUPPLIER_REQUEST = `${name}/MASS_EDIT_SET_SUPPLIER_REQUEST`;
export const MASS_EDIT_SET_SUPPLIER_SUCCESS = `${name}/MASS_EDIT_SET_SUPPLIER_SUCCESS`;
export const MASS_EDIT_SET_SUPPLIER_FAILURE = `${name}/MASS_EDIT_SET_SUPPLIER_FAILURE`;

export const GET_PRICE_GROUPS_REQUEST = `${name}/GET_PRICE_GROUPS_REQUEST`;
export const GET_PRICE_GROUPS_SUCCESS = `${name}/GET_PRICE_GROUPS_SUCCESS`;
export const GET_PRICE_GROUPS_FAILURE = `${name}/GET_PRICE_GROUPS_FAILURE`;

export default name;
